export default __webpack_public_path__ + "static/media/businessman.fdae616a.png";